"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkAsync = exports.walk = exports.walkAsyncStep = exports.walkStep = void 0;
const defaults_1 = require("./defaults");
const node_1 = require("./node");
const callback_1 = require("./callback");
const break_1 = require("./break");
class NodeQueue {
    constructor(depthFirst) {
        this.depthFirst = depthFirst;
        this.queue = [];
        this.add = depthFirst
            ? (nodes) => this.queue.unshift(...nodes)
            : (nodes) => this.queue.push(...nodes);
    }
    shift() {
        return this.queue.shift();
    }
    get more() {
        return this.queue.length > 0;
    }
}
class Walker {
    constructor(ctx) {
        this.ctx = ctx;
        this.depthFirst = ctx.config.traversalMode === 'depth';
    }
    shouldSkipVisitation(node) {
        if (!node.canBeCompared())
            return false;
        if (!this.ctx.seenObjects.has(node.val))
            this.ctx.seenObjects.add(node.val);
        else if (this.ctx.config.graphMode === 'graph')
            return true;
        else if (this.ctx.config.graphMode === 'finiteTree')
            throw "The object violates the defined structure. Override 'graphMode' in the config to allow parsing different object structures.";
        return false;
    }
    *walk(target) {
        const queue = new NodeQueue(this.depthFirst);
        const stacker = callback_1._CallbackStacker.forSync(this.ctx);
        try {
            queue.add([node_1.WalkNode.fromRoot(target)]);
            do {
                const node = queue.shift();
                if (this.shouldSkipVisitation(node))
                    continue;
                const children = node.children;
                queue.add(children);
                stacker.executeOne(node, 'preWalk');
                yield node;
                if (this.depthFirst && children.length)
                    stacker.pushToStack(node, 'postWalk');
                else {
                    stacker.executeOne(node, 'postWalk');
                    for (let _ of stacker.execute(node.id)) {
                    }
                }
            } while (queue.more);
        }
        catch (err) {
            if (!(err instanceof break_1.Break))
                throw err;
        }
    }
    walkAsync(target) {
        return __asyncGenerator(this, arguments, function* walkAsync_1() {
            var e_1, _a;
            const queue = new NodeQueue(this.depthFirst);
            const stacker = callback_1._CallbackStacker.forAsync(this.ctx);
            try {
                queue.add([node_1.WalkNode.fromRoot(target)]);
                do {
                    const node = queue.shift();
                    if (this.shouldSkipVisitation(node))
                        continue;
                    const children = node.children;
                    queue.add(children);
                    yield __await(stacker.executeOne(node, 'preWalk'));
                    yield yield __await(node);
                    if (this.depthFirst && children.length)
                        stacker.pushToStack(node, 'postWalk');
                    else {
                        yield __await(stacker.executeOne(node, 'postWalk'));
                        try {
                            for (var _b = (e_1 = void 0, __asyncValues(stacker.execute(node.id))), _c; _c = yield __await(_b.next()), !_c.done;) {
                                const _ = _c.value;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) yield __await(_a.call(_b));
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                } while (queue.more);
            }
            catch (err) {
                if (!(err instanceof break_1.Break))
                    throw err;
            }
        });
    }
}
function* walkStep(target, config = {}) {
    const ctx = defaults_1._buildContext(config);
    const walker = new Walker(ctx);
    yield* walker.walk(target);
}
exports.walkStep = walkStep;
function walkAsyncStep(target, config = {}) {
    return __asyncGenerator(this, arguments, function* walkAsyncStep_1() {
        const ctx = defaults_1._buildContext(config);
        const walker = new Walker(ctx);
        yield __await(yield* __asyncDelegator(__asyncValues(walker.walkAsync(target))));
    });
}
exports.walkAsyncStep = walkAsyncStep;
function walk(target, config = {}) {
    for (let _ of walkStep(target, config)) {
    }
}
exports.walk = walk;
function walkAsync(target, config = {}) {
    var e_2, _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            for (var _b = __asyncValues(walkAsyncStep(target, config)), _c; _c = yield _b.next(), !_c.done;) {
                let _ = _c.value;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    });
}
exports.walkAsync = walkAsync;
